import type { LiveTeamData } from '@api-service/live-team';

export type FplPosition = 'GK' | 'DEF' | 'MID' | 'FWD';

export type FplActiveChip = 'bboost' | '3xc' | 'wildcard' | 'freehit' | null;

/**
 * A single pick (starter or bench) from the FFH backend's /live/team
 * response. Re-exported as a flat type so consumers do not have to dig
 * through the generated OpenAPI shapes.
 */
export type LiveTeamPlayer = LiveTeamData['starting'][number];

/**
 * Narrow the loose `string | null` activeChip from the OpenAPI spec to
 * the actual set FPL emits.
 */
export const narrowActiveChip = (activeChip: string | null): FplActiveChip => {
  if (
    activeChip === 'bboost' ||
    activeChip === '3xc' ||
    activeChip === 'wildcard' ||
    activeChip === 'freehit'
  ) {
    return activeChip;
  }
  return null;
};
